export const constants = {
  claims: {
    title: "Claims",
    addButtonTitle: "Add Claim",
    noRecordsMatch: "No matches found. Please try another search.",
    noRecords: "No claims added yet.",
  },
  claimDetails: {
    title: "Claim Details",
    backButton: " Back to Claims",
  },
};
